export const APP_CONFIG = {
  appName: "Private Local Chat",
  domain: "privatelocalchat.benac.dev",
  sourceArchivePath: __SOURCE_PATH__,
  version: __APP_VERSION__,
  buildDate: __BUILD_DATE__,
  fixtureAudioPath: "/fixtures/assistant.wav",
  fixtureAudioLabel: "assistant.wav",
  devHarnessEnabled: import.meta.env.VITE_DEV_HARNESS_ENABLED !== "false",
  devHarnessEndpoint:
    import.meta.env.VITE_DEV_HARNESS_ENDPOINT ?? "/api/dev-harness/events",
};
